import { render, staticRenderFns } from "./BaseLoadingValue.vue?vue&type=template&id=e1c4f4c6"
import script from "./BaseLoadingValue.vue?vue&type=script&lang=js"
export * from "./BaseLoadingValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports